import React, { useState, useCallback } from "react";
import { usePdaBarcode } from "../hooks/usePdaBarcode";

/**
 * Test-only harness for validating usePdaBarcode.
 * Route: /test/pda-barcode (no auth). Renders a button that toggles the hook
 * enabled flag and exposes captured barcodes on window.__pdaBarcodes__ so
 * Playwright can inspect them.
 */
export default function PdaBarcodeTestHarness() {
  const [enabled, setEnabled] = useState(true);
  const [barcodes, setBarcodes] = useState([]);

  const onBarcode = useCallback((code) => {
    setBarcodes((prev) => {
      const next = [...prev, code];
      window.__pdaBarcodes__ = next;
      return next;
    });
  }, []);

  usePdaBarcode(onBarcode, { enabled });

  // Expose helpers to Playwright
  if (typeof window !== "undefined") {
    window.__pdaBarcodes__ = window.__pdaBarcodes__ || [];
  }

  return (
    <div style={{ padding: 20, fontFamily: "monospace" }}>
      <h1>PDA Barcode Hook Test Harness</h1>
      <div>
        <button
          data-testid="toggle-enabled"
          onClick={() => {
            setEnabled((e) => !e);
          }}
        >
          Hook enabled: {enabled ? "YES" : "NO"} (click to toggle)
        </button>
      </div>
      <div style={{ marginTop: 10 }}>
        <input data-testid="typing-input" placeholder="type here (should NOT fire scan)" />
      </div>
      <div style={{ marginTop: 10 }}>
        <button
          data-testid="clear-barcodes"
          onClick={() => {
            setBarcodes([]);
            window.__pdaBarcodes__ = [];
          }}
        >
          clear
        </button>
      </div>
      <pre data-testid="captured-barcodes">{JSON.stringify(barcodes)}</pre>
    </div>
  );
}
